<template>
        <form id="sendNoticeForm" ref="emailform">
            <p class="bold">
                {{ $translate("Snaply5::Template.singleNotificationText") }}
            </p>
            <div class="input-unit">
                <input type="email" name="email" data-autofocus="" id="emailForNote" ref="email" required>
                <label for="emailForNote">{{ $translate("Snaply5::Template.footerNewsletterEmail") }}*</label>
            </div>
            <hr>
            <button class="btn btn-primary btn-small btn-block send-notification" type="submit" @click="addToEmailReminderList($event)">
                <i class="fa fa-envelope"></i> {{ $translate("Snaply5::Template.singleNotificationButton") }}
            </button>
        </form>
</template>

<script>
    export default
    {
        data: function()
        {
            return{
                item:null,
            }
        },
        created:function()
        {
            vueEventHub.$on("email-reminder", color =>
            {
                this.item = color;
            });
        },
        methods:
            {
                addToEmailReminderList:function(e)
                {
                    e.preventDefault();
                    var _self = this;
                    var user = null;

                    if(ceresStore.state.user.userData!=null)
                    {
                        user = ceresStore.state.user.userData.id;
                    }
                    else
                    {
                        user = 0;
                    }

                    if(this.item.hasOwnProperty('data'))
                    {
                        var data =
                        {
                            "variationId" : this.item.id,
                            "itemId"      : this.item.data.item.id,
                            "customerId"  : user,
                            "customerMail": this.$refs.email.value
                        }
                    }
                    else
                    {
                        var data =
                        {
                            "variationId" : this.item.variation.id,
                            "itemId"      : this.item.item.id,
                            "customerId"  : user,
                            "customerMail": this.$refs.email.value
                        }
                    }

                    var path = '/stockmsg/entry/create/';

                    $.ajax
                    (
                        {
                            type: 'POST',
                            url: path,
                            data: data,
                            success: function (response)
                            {
                                response = JSON.parse(response);
                                if(response.hasOwnProperty('isAlreadySet')==true)
                                {
                                    CeresNotification.error(JSON.parse($('[data-translation="Snaply5::Template"]')[0].innerHTML).singleReminderAlreadySet).closeAfter(3000);

                                }
                                else
                                {
                                    CeresNotification.success(JSON.parse($('[data-translation="Snaply5::Template"]')[0].innerHTML).singleReminderThanks).closeAfter(3000);
                                }
                                $('#emailNoteModal').modal('hide');
                                _self.$refs.email.value = '';
                            },
                            error: function(response)
                            {
                                CeresNotification.error(JSON.parse($('[data-translation="Snaply5::Template"]')[0].innerHTML).singleReminderError).closeAfter(3000);
                            }
                        }
                    );

                }
            },
        computed:
        {
            reminderitem: function()
            {
                return this.item;
            }
        }
    }
</script>